import { createSlice } from "@reduxjs/toolkit";

const initialNofiticationsState = {
  notificationsList: [],
  categoriesList: [],
  listLoading: false,
  error: null,
  articlesSearch: [],
  postSearch: [],
  notificationsCreated: null
};

export const callTypes = {
  list: "list",
};
export const notificationsSlice = createSlice({
  name: "Notifications",
  initialState: initialNofiticationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        default:
          break;
      }
    },
    notificationsFetched: (state, action) => {
      state.notificationsList = action.payload.notificationsList;
      state.listLoading = false;
      state.error = null;
    },
    categoriesFetched: (state, action) => {
      state.categoriesList = action.payload.categoriesList;
      state.listLoading = false;
      state.error = null;
    },
    articlesFetched: (state, action) => {
      state.articlesSearch = action.payload.articlesSearch;
      state.listLoading = false;
      state.error = null;
    },
    postFetched: (state, action) => {
      state.postSearch = action.payload.postSearch;
      state.listLoading = false;
      state.error = null;
    },
    notificationsCreated: (state, action) => {
      state.notificationsCreated = action.payload.notificationsCreated;
      state.listLoading = false;
      state.error = null;
    },
  },
});
